const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "red",
  "orange",
  "amber",
  "yellow",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "neutral"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "root": "relative flex items-start",
    "base": [
      "inline-flex items-center shrink-0 rounded-full border-2 border-transparent focus-visible:outline-3 data-[state=unchecked]:bg-accented",
      "transition-[background] duration-200"
    ],
    "container": "flex items-center",
    "thumb": "group pointer-events-none rounded-full bg-default shadow-lg ring-0 transition-transform duration-200 data-[state=unchecked]:translate-x-0 data-[state=unchecked]:rtl:-translate-x-0 flex items-center justify-center",
    "icon": [
      "absolute shrink-0 group-data-[state=unchecked]:text-dimmed opacity-0 size-10/12",
      "transition-[color,opacity] duration-200"
    ],
    "wrapper": "ms-2",
    "label": "block font-medium text-default",
    "description": "text-muted"
  },
  "variants": {
    "color": {
      "primary": {
        "base": "data-[state=checked]:bg-primary outline-primary/25",
        "icon": "group-data-[state=checked]:text-primary"
      },
      "secondary": {
        "base": "data-[state=checked]:bg-secondary outline-secondary/25",
        "icon": "group-data-[state=checked]:text-secondary"
      },
      "success": {
        "base": "data-[state=checked]:bg-success outline-success/25",
        "icon": "group-data-[state=checked]:text-success"
      },
      "info": {
        "base": "data-[state=checked]:bg-info outline-info/25",
        "icon": "group-data-[state=checked]:text-info"
      },
      "warning": {
        "base": "data-[state=checked]:bg-warning outline-warning/25",
        "icon": "group-data-[state=checked]:text-warning"
      },
      "error": {
        "base": "data-[state=checked]:bg-error outline-error/25",
        "icon": "group-data-[state=checked]:text-error"
      },
      "red": {
        "base": "data-[state=checked]:bg-red outline-red/25",
        "icon": "group-data-[state=checked]:text-red"
      },
      "orange": {
        "base": "data-[state=checked]:bg-orange outline-orange/25",
        "icon": "group-data-[state=checked]:text-orange"
      },
      "amber": {
        "base": "data-[state=checked]:bg-amber outline-amber/25",
        "icon": "group-data-[state=checked]:text-amber"
      },
      "yellow": {
        "base": "data-[state=checked]:bg-yellow outline-yellow/25",
        "icon": "group-data-[state=checked]:text-yellow"
      },
      "green": {
        "base": "data-[state=checked]:bg-green outline-green/25",
        "icon": "group-data-[state=checked]:text-green"
      },
      "emerald": {
        "base": "data-[state=checked]:bg-emerald outline-emerald/25",
        "icon": "group-data-[state=checked]:text-emerald"
      },
      "teal": {
        "base": "data-[state=checked]:bg-teal outline-teal/25",
        "icon": "group-data-[state=checked]:text-teal"
      },
      "cyan": {
        "base": "data-[state=checked]:bg-cyan outline-cyan/25",
        "icon": "group-data-[state=checked]:text-cyan"
      },
      "blue": {
        "base": "data-[state=checked]:bg-blue outline-blue/25",
        "icon": "group-data-[state=checked]:text-blue"
      },
      "indigo": {
        "base": "data-[state=checked]:bg-indigo outline-indigo/25",
        "icon": "group-data-[state=checked]:text-indigo"
      },
      "purple": {
        "base": "data-[state=checked]:bg-purple outline-purple/25",
        "icon": "group-data-[state=checked]:text-purple"
      },
      "pink": {
        "base": "data-[state=checked]:bg-pink outline-pink/25",
        "icon": "group-data-[state=checked]:text-pink"
      },
      "neutral": {
        "base": "data-[state=checked]:bg-inverted outline-inverted/25",
        "icon": "group-data-[state=checked]:text-highlighted"
      }
    },
    "size": {
      "xs": {
        "base": "w-7",
        "container": "h-4",
        "thumb": "size-3 data-[state=checked]:translate-x-3 data-[state=checked]:rtl:-translate-x-3",
        "wrapper": "text-xs"
      },
      "sm": {
        "base": "w-8",
        "container": "h-4",
        "thumb": "size-3.5 data-[state=checked]:translate-x-3.5 data-[state=checked]:rtl:-translate-x-3.5",
        "wrapper": "text-xs"
      },
      "md": {
        "base": "w-9",
        "container": "h-5",
        "thumb": "size-4 data-[state=checked]:translate-x-4 data-[state=checked]:rtl:-translate-x-4",
        "wrapper": "text-sm"
      },
      "lg": {
        "base": "w-10",
        "container": "h-5",
        "thumb": "size-4.5 data-[state=checked]:translate-x-4.5 data-[state=checked]:rtl:-translate-x-4.5",
        "wrapper": "text-sm"
      },
      "xl": {
        "base": "w-11",
        "container": "h-6",
        "thumb": "size-5 data-[state=checked]:translate-x-5 data-[state=checked]:rtl:-translate-x-5",
        "wrapper": "text-base"
      }
    },
    "checked": {
      "true": {
        "icon": "group-data-[state=checked]:opacity-100"
      }
    },
    "unchecked": {
      "true": {
        "icon": "group-data-[state=unchecked]:opacity-100"
      }
    },
    "loading": {
      "true": {
        "icon": "animate-spin"
      }
    },
    "highlight": {
      "true": ""
    },
    "required": {
      "true": {
        "label": "after:content-['*'] after:ms-0.5 after:text-error"
      }
    },
    "disabled": {
      "true": {
        "root": "opacity-75",
        "base": "cursor-not-allowed",
        "label": "cursor-not-allowed",
        "description": "cursor-not-allowed"
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-primary"
      }
    },
    {
      "color": "secondary" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-secondary"
      }
    },
    {
      "color": "success" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-success"
      }
    },
    {
      "color": "info" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-info"
      }
    },
    {
      "color": "warning" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-warning"
      }
    },
    {
      "color": "error" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-error"
      }
    },
    {
      "color": "red" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-red"
      }
    },
    {
      "color": "orange" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-orange"
      }
    },
    {
      "color": "amber" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-amber"
      }
    },
    {
      "color": "yellow" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-yellow"
      }
    },
    {
      "color": "green" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-green"
      }
    },
    {
      "color": "emerald" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-emerald"
      }
    },
    {
      "color": "teal" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-teal"
      }
    },
    {
      "color": "cyan" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-cyan"
      }
    },
    {
      "color": "blue" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-blue"
      }
    },
    {
      "color": "indigo" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-indigo"
      }
    },
    {
      "color": "purple" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-purple"
      }
    },
    {
      "color": "pink" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-pink"
      }
    },
    {
      "color": "neutral" as typeof color[number],
      "highlight": true,
      "class": {
        "base": "ring ring-inverted"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "size": "md" as typeof size[number]
  }
}